import { render, staticRenderFns } from "./levConfirmacao.vue?vue&type=template&id=7323a3b4&scoped=true"
import script from "./levConfirmacao.vue?vue&type=script&lang=js"
export * from "./levConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./levConfirmacao.vue?vue&type=style&index=0&id=7323a3b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7323a3b4",
  null
  
)

export default component.exports